module.exports = __webpack_public_path__ + "img/180.04f4f014.jpg";